import { render, staticRenderFns } from "./BindPaymentMethodModal.vue?vue&type=template&id=27a68f68&"
import script from "./BindPaymentMethodModal.vue?vue&type=script&lang=ts&"
export * from "./BindPaymentMethodModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports